module.exports = __webpack_public_path__ + "img/cloud1_3.b51bbf67.png";